import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes } from '@fortawesome/pro-regular-svg-icons';
import { useBaseModal } from './BaseModalContext';
import styles from './CenteredModalHeader.module.scss';

interface CenteredModalHeaderProps {
    title?: string;
    showCloseButton?: boolean;
    children?: React.ReactNode;
    className?: string;
}

export const CenteredModalHeader: React.FC<CenteredModalHeaderProps> = ({
    title,
    showCloseButton = true,
    children,
    className
}) => {
    const { onClose } = useBaseModal();

    return (
        <div className={`${styles.modalHeader} ${className || ''}`}>
            <div className={styles.headerContent}>
                {title && (
                    <h2 className={styles.title}>{title}</h2>
                )}
                {children}
            </div>
            
            {showCloseButton && (
                <button 
                    className={styles.closeButton}
                    onClick={onClose}
                    aria-label="Close modal"
                >
                    <FontAwesomeIcon icon={faTimes} />
                </button>
            )}
        </div>
    );
};

export default CenteredModalHeader;
